import { mapGetters } from 'vuex'

export default {
    name: 'crypto-payment-popup',
    props: {
        amount: {
            type: Number,
            required: true
        },
        treeCount: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            isAgreed: false,
            isLoading: false
        }
    },
    computed: {
        ...mapGetters([
            'currentLanguage',
        ]),
        title() {
            return this.currentLanguage.key === 'ru'
                ? 'Оплата криптовалютой'
                : 'Cryptocurrency Payment'
        },
        text() {
            return this.currentLanguage.key === 'ru'
                ? 'Перед отправкой средств убедитесь, что вы учли комиссию сети.'
                : 'Please make sure you take into account network fees before sending funds.'
        },
        text_2() {
            return this.currentLanguage.key === 'ru'
                ? 'Не закрывайте страницу оплаты!'
                : 'Do not close the payment page!'
        },
        text_3() {
            return this.currentLanguage.key === 'ru'
                ? 'Пожалуйста, не закрывайте эту страницу до завершения обработки платежа.'
                : 'Please do not close this page until your payment is processed.'
        },
        confirmButtonText() {
            return this.currentLanguage.key === 'ru'
                ? 'Подтвердить оплату'
                : 'Confirm Payment'
        },
        loadingText() {
            return this.currentLanguage.key === 'ru'
                ? 'Загрузка...'
                : 'Loading...'
        },
        agreementText() {
            return this.currentLanguage.key === 'ru'
                ? 'Я подтверждаю, что ознакомился с информацией и согласен с условиями.'
                : 'I confirm that I have read the information and agree to the terms.'
        },
        buttonText() {
            return this.isLoading ? this.loadingText : this.confirmButtonText
        }
    },
    methods: {
        confirmPayment() {
            if (this.isAgreed && !this.isLoading) {
                this.isLoading = true;
                // Здесь вы можете добавить логику для обработки платежа
                // Например, вызов API или другие асинхронные операции
                this.$emit('confirm');
            }
        },
        closePopup() {
            if (!this.isLoading) {
                this.$emit('close');
            }
        },
    },
}